<template>
<div>
  <h2 v-if="mask">{{mask.title}}</h2>
  <CheckableTreeView v-if="maskData" ref="displayMaskTreeView" :data="maskData" :prettyDisplay="true" />
  <div v-else>{{$t('reports.errors.no_mask_selected')}}</div>
</div>
</template>

<script>
import Vue from 'vue'
import skills from '../data/reportsskills.json'

export default {
  name: "MaskDisplay",

  props: {
    mask: {
      type: Object,
      default: null
    },
  },

  watch:
  {
    mask: function(newV)
    {
      this.openMask(newV);
    }
  },

  data: () => ({
    maskData: null
  }),

  mounted () {
    if(this.mask) {
      this.openMask(this.mask);
    }
    else {
      this.maskData = [this.initTreeViewData(skills.slice()[0])];
    }
  },

  methods: {
    initTreeViewData(data)
    {
      data.masked = true;
      if(data.children.length > 0) {
        for(var i = 0; i < data.children.length; i++)
          data.children[i] = this.initTreeViewData(data.children[i]);
      }
      return data;
    },

    $_load(mask, index, data) {
      index.value++;

      for (let i = 0; i < data.length; i++) {
        let node = data[i];
        let masked = mask.mask[index.value] == "0";

        Vue.set(node, 'masked', masked);

        if (masked) {
          index.value++;
          continue;
        } else {
          this.$_load(mask, index, node.children);
        }
      }
    },

    load (mask, data) {
      if (mask.mask[0] == "0") {
        Vue.set(data[0], 'masked', true);
      }

      const index = { value: 0 };
      this.$_load(mask, index, data[0].children);
    },

    openMask(mask)
    {
      var tmpData = [this.initTreeViewData(skills.slice()[0])];
      this.load(mask, tmpData);
      this.maskData = tmpData;
      if(this.$refs.displayMaskTreeView) // prevent code being executed before the v-if trigger the mounted methods of treeviews
        this.$refs.displayMaskTreeView.refresh();
    }
  }
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/components/MaskDisplay.vue